import Vue from "vue";
import Vuetify from "vuetify";
import { VTextField } from "vuetify/lib/components/VTextField";
import { VSelect } from "vuetify/lib/components/VSelect";
import { VAutocomplete } from "vuetify/lib/components/VAutocomplete";
import { VTextarea } from "vuetify/lib/components/VTextarea";
import ru from "vuetify/lib/locale/ru";

// Set outlined as default for all inputs globally
VTextField.options.props.outlined.default = true;
VSelect.options.props.outlined.default = true;
VAutocomplete.options.props.outlined.default = true;
VTextarea.options.props.outlined.default = true;

const bottomMenu = { bottom: true, offsetY: true };
VSelect.options.props.menuProps.default = () => bottomMenu;
VAutocomplete.options.props.menuProps.default = () => bottomMenu;

// Disable auto-validation on blur globally
// Validation only fires on form.validate() (submit)
VTextField.options.methods.onBlur = function (e) {
  this.isFocused = false;
  e && this.$emit("blur", e);
};
VSelect.options.methods.onBlur = function (e) {
  this.isFocused = false;
  this.isMenuActive = false;
  e && this.$emit("blur", e);
};
VAutocomplete.options.methods.onBlur = function (e) {
  this.isFocused = false;
  this.isMenuActive = false;
  e && this.$emit("blur", e);
};
VTextarea.options.methods.onBlur = function (e) {
  this.isFocused = false;
  e && this.$emit("blur", e);
};

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      dropdown: "mdi-chevron-down",
    },
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#00274c",
        secondary: "#ffcb05",
        accent: "#00274c",
        // error: "#FF5252",
        info: "#00274c",
        // success: "#4CAF50",
        // warning: "#FFC107",
      },
      dark: {
        primary: "#ffd451",
        secondary: "#ffcb05",
        accent: "#4da3ff",
        info: "#4da3ff",
      },
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { ru },
    current: "ru",
  },
});
